var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"value":_vm.value,"items":_vm.agencyMarginList,"loading":_vm.loading,"label":"代理店マージン（必須）","clearable":""},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }